/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiHeaderItem } from '../../models/AaiHeaderItem';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @class
 * @extends AaiHeaderItem
 * @author Jakub Senko <jsenko@redhat.com>
 */
export class Aai20HeaderItem extends AaiHeaderItem {
    public constructor(parent? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null)) {
            let __args = arguments;
            super(parent);
        } else if(parent === undefined) {
            let __args = arguments;
            super();
        } else throw new Error('invalid overload');
    }
}
Aai20HeaderItem["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20HeaderItem";
Aai20HeaderItem["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode"];




